export enum CreditNotesListTabsEnum {
  DRAFT = 'draft',
  OPEN = 'open',
  PAID = 'paid',
  CANCELED = 'canceled',
  DELETED = 'deleted',
  ALL = 'all',
}
